import { useEffect } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { SarlaftSurveyProps } from './props';
import { SarlaftSurvey } from '../../../../../../shared/types/modules/sarlaft';

export const useSarlaftSurvey = ({
    data,
    onChangeData,
    onChangeFormik,
}: SarlaftSurveyProps) => {
    const onSubmit = (data: SarlaftSurvey) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue(
            'wieldsPoliticalPower',
            data?.wieldsPoliticalPower || ''
        );
        formik?.setFieldValue(
            'generalPublicRecognition',
            data?.generalPublicRecognition || ''
        );
        formik?.setFieldValue(
            'taxesOtherCountries',
            data?.taxesOtherCountries || ''
        );
        formik?.setFieldValue(
            'publiclyExposedPerson',
            data?.publiclyExposedPerson || ''
        );
        formik?.setFieldValue('which', data?.which || '');
        formik?.setFieldValue(
            'managesPublicResources',
            data?.managesPublicResources || ''
        );
    }, [data]);

    return {
        formik,
    };
};
